import React from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import { ReactSortable } from "react-sortablejs";
import { withTranslation } from 'react-i18next';

const mapStateToProps = (state, ownProps) => ({})

const mapDispatchToProps = (dispatch, ownProps) => ({})

class AddModulePanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newModulesList: [
        {
          type: "audio",
          name: "Audio",
          icon: "icon-sound",
          img: "card-audio.png",
        },
        {
          type: "video",
          name: "Video",
          icon: "icon-video-1",
          img: "card-video.png",
        },
        {
          type: "film",
          name: "Film",
          icon: "icon-video",
          img: "card-video.png",
        },
        {
          type: "image",
          name: "Image",
          icon: "icon-picture-1",
          img: "card-image.png",
        }, {
          type: "qa",
          name: "Q&A",
          icon: "icon-language-1",
          img: "card-qa.png",
        }
      ]
    };
  }

  componentDidMount() {

  }

  addThis(card) {
    const { onClickAdd } = this.props;

    if (onClickAdd)
      onClickAdd(card);
  }

  render() {
    const { newModulesList } = this.state;
    const { onChoose, onUnchoose, t, testType, existModuleFilm } = this.props;

    let newModulesListFiltered = [];
    if (testType === 'film') {
      newModulesListFiltered = newModulesList.filter(modules => {
        return modules.type === 'qa' || modules.type === 'film';
      });
    } else {
      newModulesListFiltered = newModulesList.filter(modules => {
        return modules.type !== 'film';
      });
    }

    const renderNewModulesList = newModulesListFiltered.map((card, key) => {
      let cardName = t("Panels_Audio_Capital_Letter");

      if (card.type === "video"){
        cardName = t("Panels_Video_Capital_Letter");
      } else if (card.type === "film"){
        cardName = t("Panels_Large_Video_Capital_Letter");
      } else if (card.type === "image"){
        cardName = t("Panels_Image_Capital_Letter");
      } else if (card.type === "qa"){
        cardName = t("Panels_QA_Capital_Letter");
      }

      let disabledClass = '';
      if (testType === 'film' && card.type === 'film' && existModuleFilm) {
        disabledClass = 'disabled';
      }

      return (
        <li key={key} className={`screen-card ${card.type} ${disabledClass}`} onClick={() => this.addThis(card)}>
          <div className={`module ${card.type}`}>
            <i className={`icon ${card.icon} module-type-icon`}></i>
            <h4>{cardName}</h4>
            <i className="icon icon-plus-1"></i>
          </div>
          <div className="card-header">{card.name}</div>
          <div className="card-body"><img src={`./img/${card.img}`} alt={`card ${card.type} icon`} /></div>
        </li>
      )
    })

    return (
      <div className="panel panel-add-screen">
        <div className="screen-modules">
          <ReactSortable
            id="sortable-b"
            tag="ul"
            list={newModulesListFiltered}
            setList={newState => {}}
            group={{
              name: "shared",
              pull: "clone",
              put: false
            }}
            sort={false}
            onChoose={e => onChoose()}
            onUnchoose={e => onUnchoose()}
            onChange={e => this.checkCampaignModulesEmpty()}
          >
            {renderNewModulesList}
          </ReactSortable>
        </div>
      </div>
    );
  }
}

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(AddModulePanel);
